import {JiraObject, WorkstreamMetric} from 'client';
import {CURRENT_QUARTER, CURRENT_YEAR} from 'constant';

import {getSoonestMetricDate, isWorkstreamMetric} from './utils';

const getDisplayMetricForecast = (metric: WorkstreamMetric) => {
  const currentPeriod = `${CURRENT_YEAR}Q${CURRENT_QUARTER}`;
  const eligibleForecasts = (metric.metric_forecasts ?? []).filter(
    (forecast) => forecast.period && forecast.period >= currentPeriod
  );

  if (eligibleForecasts.length === 0) {
    return undefined;
  }

  return eligibleForecasts.reduce((earliest, forecast) => {
    const earliestTime = earliest.forecast_date
      ? new Date(earliest.forecast_date).getTime()
      : Infinity;
    const forecastTime = forecast.forecast_date
      ? new Date(forecast.forecast_date).getTime()
      : Infinity;

    if (forecastTime !== earliestTime) {
      return forecastTime < earliestTime ? forecast : earliest;
    }

    return forecast.period < earliest.period ? forecast : earliest;
  });
};

const getDisplayMetricDate = (metric: WorkstreamMetric) =>
  getDisplayMetricForecast(metric)?.forecast_date ?? getSoonestMetricDate(metric);

export const sortMetricsByCompleteDate = (
  a: WorkstreamMetric | JiraObject,
  b: WorkstreamMetric | JiraObject
) => {
  const aDate = isWorkstreamMetric(a) ? getDisplayMetricDate(a) : a.complete_date;
  const bDate = isWorkstreamMetric(b) ? getDisplayMetricDate(b) : b.complete_date;

  const aTime = aDate ? new Date(aDate).getTime() : Infinity;
  const bTime = bDate ? new Date(bDate).getTime() : Infinity;

  return aTime - bTime;
};
